import React from 'react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-[#111827] py-12" data-id="element-65">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-66">
        <a href="#plano" className="mb-6" data-id="element-67">
          <Logo showText={true} size="md" variant="light" data-id="element-68" />
        </a>
        <p className="text-gray-400 text-sm text-center" data-id="element-69">
          © 2026 Obra Digital. Todos los derechos reservados.
        </p>
        <div className="mt-4 flex items-center gap-4" data-id="element-70">
          <a href="#brand" className="text-gray-600 text-xs hover:text-gray-400 transition-colors" data-id="element-71">
            Brand
          </a>
          <span className="text-gray-700 text-xs" data-id="element-72">·</span>
          <a href="#plano" className="text-gray-600 text-xs hover:text-gray-400 transition-colors" data-id="element-73">
            Plano
          </a>
          <span className="text-gray-700 text-xs" data-id="element-74">·</span>
          <a href="#pinfotos" className="text-gray-600 text-xs hover:text-gray-400 transition-colors" data-id="element-75">
            Pin Fotos
          </a>
        </div>
      </div>
    </footer>;
}